// Full palette as CSS-variable-friendly values (source of truth for SCSS at runtime)
export const themePalette = {
    inkBlack: '#001219',
    darkTeal: '#005f73',
    darkCyan: '#0a9396',
    pearlAqua: '#94d2bd',
    vanillaCustard: '#e9d8a6',
    goldenOrange: '#ee9b00',
    burntCaramel: '#ca6702',
    rustySpice: '#bb3e03',
    oxidizedIron: '#ae2012',
    brownRed: '#9b2226',
    white: '#ffffff',
};

// Ant Design token values (used by ConfigProvider)
export const themeTokens = {
    colorPrimary: themePalette.darkCyan,
    colorText: themePalette.inkBlack,
    colorBgBase: themePalette.white,
    colorInfo: themePalette.pearlAqua,
    colorWarning: themePalette.goldenOrange,
    colorError: themePalette.brownRed,
    fontFamily: "'Varela Round', system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};

// Layout dimensions (in pixels)
export const layoutDimensions = {
    headerHeight: 64,
    footerHeight: 70,
};

// Apply the palette and semantic tokens as CSS custom properties on :root.
// Call this at app startup so SCSS that references CSS variables uses the values from this palette.
export function applyThemeToRoot(tokens = themeTokens, palette = themePalette, dimensions = layoutDimensions) {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;

  // Set palette variables
  root.style.setProperty('--ink-black', palette.inkBlack);
  root.style.setProperty('--dark-teal', palette.darkTeal);
  root.style.setProperty('--dark-cyan', palette.darkCyan);
  root.style.setProperty('--pearl-aqua', palette.pearlAqua);
  root.style.setProperty('--vanilla-custard', palette.vanillaCustard);
  root.style.setProperty('--golden-orange', palette.goldenOrange);
  root.style.setProperty('--burnt-caramel', palette.burntCaramel);
  root.style.setProperty('--rusty-spice', palette.rustySpice);
  root.style.setProperty('--oxidized-iron', palette.oxidizedIron);
  root.style.setProperty('--brown-red', palette.brownRed);

  // Set semantic variables (keeps existing SCSS using these names working)
  root.style.setProperty('--primary-color', tokens.colorPrimary);
  root.style.setProperty('--text-color', tokens.colorText);
  root.style.setProperty('--background-color', tokens.colorBgBase);
  root.style.setProperty('--secondary-color', tokens.colorInfo);
  // expose font family token as a CSS variable for SCSS to consume
  if (tokens.fontFamily) {
    root.style.setProperty('--ui-font', tokens.fontFamily);
  }

  // Set layout dimension variables
  root.style.setProperty('--header-height', `${dimensions.headerHeight}px`);
  root.style.setProperty('--footer-height', `${dimensions.footerHeight}px`);
}